const FIELD_TYPE_STRING = 'string';
const FIELD_TYPE_INT = 'int';
const FIELD_TYPE_FLOAT = 'float';
const FIELD_TYPE_BOOL = 'bool';
const FIELD_TYPE_DATE = 'date';

export default {
	
	type: {
		STRING: FIELD_TYPE_STRING,
		INT: FIELD_TYPE_INT,
		FLOAT: FIELD_TYPE_FLOAT,
		BOOL: FIELD_TYPE_BOOL,
		DATE: FIELD_TYPE_DATE
	},
	
	decode: function (modelClass, json, params) {
		if (json) {
			if (Array.isArray(json)) {
				let items = [];
				json.forEach((jsonItem) => {
					let model = modelClass.create(jsonItem, params);
					if (model !== null) {
						items.push(model)
					}
				});
				return items
			} else {
				return modelClass.create(json, params)
			}
		}
		return null
	},
	
	getObjectValue: function (obj, key) {
		return key.split(".").reduce(function (o, x) {
			return (typeof o == "undefined" || o === null) ? o : o[x];
		}, obj);
	},
	
	value: function (type, value, defaultValue) {
		if (value === null || value === undefined) {
			return defaultValue !== undefined ? defaultValue : null
		}
		
		switch (type) {
			case FIELD_TYPE_BOOL:
				return value === 1 || value === '1' || value === true || value === 'true' || value === 'Y'
			case FIELD_TYPE_INT:
				value = parseInt(value);
				if (isNaN(value)) {
					value = 0
				}
				return value
			case FIELD_TYPE_FLOAT:
				value = parseFloat(value);
				if (isNaN(value)) {
					value = 0
				}
				return value
			case FIELD_TYPE_DATE:
				if (typeof value === 'string' && value !== '') {
					let date = new Date(Date.parse(value.replace('-', '/')));
					if (!isNaN(date.getTime())) {
						return date
					}
				}
				return defaultValue !== undefined ? defaultValue : null
			case FIELD_TYPE_STRING:
				return '' + value
		}
		
		return null
	},
	
	boolValue: function (value, defaultValue) {
		return this.value(FIELD_TYPE_BOOL, value, defaultValue)
	},
	
	intValue: function (value, defaultValue) {
		return this.value(FIELD_TYPE_INT, value, defaultValue)
	},
	
	floatValue: function (value, defaultValue) {
		return this.value(FIELD_TYPE_FLOAT, value, defaultValue)
	},
	
	dateValue: function (value, defaultValue) {
		return this.value(FIELD_TYPE_DATE, value, defaultValue)
	},
	
	stringValue: function (value, defaultValue) {
		return this.value(FIELD_TYPE_STRING, value, defaultValue)
	}
}